import { render } from "./radioInputsPayment.vue?vue&type=template&id=684d1fda"
import script from "./radioInputsPayment.vue?vue&type=script&lang=js"
export * from "./radioInputsPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__